export default __webpack_public_path__ + "static/media/Circle-Close-Icon.9d4e5e38.svg";